











































































import { Vue, Component, Prop, Emit, Ref } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import {
  DateInput,
} from "@/components/inputs";
import { IStockService, IPatientService, IDrugService } from '@/interfaces/Services';
import { required } from '@/utils/validation';
import { PatientModel } from '@/models/patient';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { DrugModel } from '../../models/drug';
import { StockItemModel } from '../../models/stock';

@Component({components: {
  DateInput,
}})
export class StockAddDialogButton extends Vue {
  @inject(DependencyIdentifiers.StockService)
  private stockService!: IStockService;
  @inject(DependencyIdentifiers.DrugService)
  private drugService!: IDrugService;
  @inject(DependencyIdentifiers.PatientService)
  private patientService!: IPatientService;

  @Prop() private patient!: PatientModel;
  @Prop() private drug!: DrugModel;
  @Ref() form: any;

  private isLoading = false;
  private dialog = false;
  private componentKey = 0;
  private drugs: {text:string, value:string}[] = [];

  private formData = { drugId: '', amount: 1, lotId: '', expiredAt: '' };
  private get formConfig() {
    return {
      drugId: {
        label: this.$t('stock.columns.drug'),
        rules: [(v: string | undefined) => !!this.drug || !!v || this.$t("validator.required")]
      },
      amount: {
        label: this.$t('stock.columns.amount'),
        rules: [required]
      },
      lotId: {
        label: this.$t('stock.columns.lotId'),
        rules: [required]
      },
      expiredAt: {
        label: this.$t('stock.columns.expiredAt'),
        rules: []
      }
    };
  }

  async mounted() {
    this.isLoading = true;
    if (this.drug) {
      this.formData.drugId = this.drug.$id!;
    } else {
      await this.fetchDrugs();
    }
  }

  hasSelectedDrug() {
    return !!this.drug;
  }

  async fetchDrugs() {
    await this.drugService.getMany(1, 100)
      .then(([result, counter]) => {
        return result.map(item => ({text: item.name, value: item.$id!}))
      })
      .then(result => {
        this.drugs = result.sort((a, b) => a.text == b.text ? 0 : a.text < b.text ? -1 : 1);
      })
      .finally(() => this.isLoading = false);
  }

  async save() {
    if (!this.form.validate()) {
      return;
    }

    this.isLoading = true;
    await this.stockService.create({
      $patientId: this.patient.$id!,
      $drugId: this.formData.drugId,
      amount: this.formData.amount,
      lotId: this.formData.lotId,
      $expiredAt: this.formData.expiredAt ? new Date(this.formData.expiredAt).toISOString() : undefined,
    }).then((results) => {
      this.isLoading = false;
      this.saved(results);
      this.close();
    });
  }

  @Emit('close')
  close() {
    this.dialog = false
  }

  @Emit('saved')
  async saved(items: StockItemModel[]) {
    return items;
  }
}

export default StockAddDialogButton;
